import { Button } from "@chakra-ui/react";
import { DisruptedCTAProps } from "../DisruptedCTA";
import { Flex } from "@chakra-ui/react";

const BUTTON_PRIMARY_TEXT = "Continue claim";
const BUTTON_SECONDARY_TEXT = "Other reason";

function CopyCTA1({ t, onAnotherClaimReasonClick, onSubmit, isSubmitting }: DisruptedCTAProps) {
  return (
    <Flex direction={{ base: "column-reverse", md: "row" }} gap="4">
      <Button
        size="l"
        variant="secondary"
        onClick={onAnotherClaimReasonClick}
        disabled={isSubmitting}
        data-testid="claim-flight-for-another-reason-button"
      >
        {BUTTON_SECONDARY_TEXT}
      </Button>
      <Button
        size="l"
        onClick={onSubmit}
        isLoading={isSubmitting}
        data-testid="claim-flight-button"
      >
        <span>{BUTTON_PRIMARY_TEXT}</span>
      </Button>
    </Flex>
  );
}

export default CopyCTA1;
